import { DataGrid } from '@mui/x-data-grid';
import React, { useState, useEffect } from 'react';
import { DataGridContainer } from '../../../Episode/Episode.Styled';
import { Auth } from 'aws-amplify';
import { getStopApi } from '../../../../services/StopApi/StopApi';
import { CBP_RATES_LIST } from '../../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import CBPRatesDialog from './CBPRatesDialog';
import {
  getCbpRatesFormData,
  newCbpRates,
} from '../../../../redux/cbp/cbpRates/cbpRatesFormSlice';
import { getCbpRatesReferenceData } from '../../../../redux/cbp/cbpRates/cbpRatesReferenceData';
import { ButtonGrid } from '../../../ui/styled';
import { Button, Grid } from '@mui/material';
import { renderCellExpand } from '../../../common/GridCell/GridCellExpand';

const CbpRates = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [openCBPRatesDialog, setOpenCBPRatesDialog] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const cbpId = useSelector((state) => state.cbpForm?.cboID);
  const [cbpRates, setCBPRates] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
  });
  const [cbpRateInvoices, setCBPRateInvoices] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
  });
  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken && cbpId) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    cbpRates.pageSize,
    cbpRates.page,
    cbpId,
  ]);

  const fetchData = async () => {
    setCBPRates((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${CBP_RATES_LIST}/${cbpId}/rte/list?PageNumber=${cbpRates.page}&PageSize=${cbpRates.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getCbpRatesReferenceData(authorization));
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      setCBPRates((prveState) => ({
        ...prveState,
        isLoading: false,
        total: response.totalRows,
        data: json?.map((item, index) => ({
          ...item,
          id: index,
          CBPRteID: item.CBPRteID ? item.CBPRteID : '-',
          Start: item.Start ? item.Start : '-',
          End: item.End ? item.End : '-',
          TmtType: item.TmtType ? item.TmtType : '-',
          Amount: `$${item.Amount}`,
          DARSApprovedCountRteMn: item.DARSApprovedCountRteMn,
          DARSApprovedCountRteMx: item.DARSApprovedCountRteMx,
          UnitsPerDay: item.UnitsPerDay,
          UnitsPerWeek: item.UnitsPerWeek,
          TotalUnits: item.TotalUnits,
          TotalAmount: `$${item.TotalAmount}`,
          UtilizationReq: item.UtilizationReq,
          RateInactive: item.RateInactive,
          MonthlySettlement: item.MonthlySettlement,
          Comment: item.Comment ? item.Comment : '-',
        })),
      }));
    }).catch((e) => alert(e));
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const cbpCaseRatesClick = (params) => {
    const commonParams = `${CBP_RATES_LIST}/rte/${params.row.CBPRteID}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response?.data?.Invoices;
      setCBPRateInvoices((prevState) => ({
        ...prevState,
        isLoading: false,
        total: json?.length,
        data: json?.map((item, index) => ({
          ...item,
          id: index,
          CBPInvID: item.CBPInvID,
          month: item.month ? item.month : '-',
          allocatedUnits: item.allocatedUnits ? item.allocatedUnits : '-',
          allocatedCumltvUnits: item.allocatedCumltvUnits,
          allocatedAmount: item.allocatedAmount ? item.allocatedAmount : '-',
          utilizationReqBpaDcp: item.utilizationReqBpaDcp,
          utilizationReqUnits: item.utilizationReqUnits,
          utilizationReqCumltvUnits: item.utilizationReqCumltvUnits,
          actualTotalUnits: item.actualTotalUnits ? item.actualTotalUnits : '-',
          actualCumltiveUnits: item.actualCumltiveUnits
            ? item.actualCumltiveUnits
            : '-',
          invoiceAmount: `$${item.invoiceAmount}`,
        })),
      }));
    }).catch((e) => alert(e));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 700);
    dispatch(getCbpRatesFormData({ commonParams, authorization }));
    setOpenCBPRatesDialog(true);
  };

  const openNewCbpRatesDialog = () => {
    const newCbpRatesPayload = {
      CBPRteID: 0,
      Start: '',
      End: '',
      TmtType: '',
      Amount: '',
      DARSApprovedCountRteMn: '',
      DARSApprovedCountRteMx: '',
      UnitsPerDay: '',
      UnitsPerWeek: '',
      TotalUnits: '',
      TotalAmount: '',
      UtilizationReq: '',
      RateInactive: '',
      MonthlySettlement: '',
      Comment: '',
      newCbpRates: true,
    };
    dispatch(newCbpRates(newCbpRatesPayload));
    setOpenCBPRatesDialog(true);
  };

  const columnsData = [
    {
      field: 'CBPRteID',
      headerName: 'CBP RteID',
      flex: 1,
    },
    {
      field: 'Start',
      headerName: 'Rate Term Start',
      sortable: false,
      minWidth: 80,
      flex: 1,
    },
    {
      field: 'End',
      headerName: 'Rate Term End',
      sortable: false,
      minWidth: 80,
      flex: 1,
    },
    {
      field: 'TmtType',
      headerName: 'Tmt Type',
      sortable: false,
      flex: 1,
    },
    {
      field: 'Amount',
      headerName: 'Amount',
      sortable: false,
      flex: 1,
    },
    {
      field: 'DARSApprovedCountRteMn',
      headerName: 'DARS approved County Rte Mn',
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: 'DARSApprovedCountRteMx',
      headerName: 'DARS approved County Rte Mx',
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: 'UnitsPerDay',
      headerName: '# Units Per Day',
      minWidth: 90,
      sortable: false,
    },
    {
      field: 'UnitsPerWeek',
      headerName: '# Units Per Week',
      minWidth: 90,
      sortable: false,
    },
    {
      field: 'TotalUnits',
      headerName: 'Total Units',
      sortable: false,
      flex: 1,
    },
    {
      field: 'TotalAmount',
      headerName: 'Total Amount',
      sortable: false,
      flex: 1,
    },
    {
      field: 'UtilizationReq',
      headerName: 'Utilization Req %',
      sortable: false,
      flex: 1,
    },
    {
      field: 'RateInactive',
      headerName: 'Rate Inactive',
      sortable: false,
      type: 'boolean',
      flex: 1,
    },
    {
      field: 'MonthlySettlement',
      headerName: 'Monthly Settlement',
      sortable: false,
      type: 'boolean',
      flex: 1,
    },
    {
      field: 'Comment',
      headerName: 'comment',
      sortable: false,
      renderCell: renderCellExpand,
      flex: 1,
    },
  ];
  return (
    <>
      <Grid container>
        <ButtonGrid item xs={12}>
          <Button variant='contained' onClick={() => openNewCbpRatesDialog()}>
            New CBP Rates
          </Button>
        </ButtonGrid>
        <Grid item xs={12}>
          <DataGridContainer>
            <DataGrid
              getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={cbpRates.data}
              page={cbpRates.page - 1}
              rowCount={cbpRates.total}
              rowsPerPageOptions={[10, 25, 50]}
              pageSize={cbpRates.pageSize}
              pagination
              paginationMode='server'
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              onPageSizeChange={(newPageSize) =>
                setCBPRates((prveState) => ({
                  ...prveState,
                  pageSize: newPageSize,
                }))
              }
              onPageChange={(newPage) => {
                setCBPRates((prveState) => ({
                  ...prveState,
                  page: newPage + 1,
                }));
              }}
              loading={cbpRates.isLoading}
              onRowClick={(param) => cbpCaseRatesClick(param)}
              disableColumnFilter
              disableColumnMenu
            />
          </DataGridContainer>
        </Grid>
      </Grid>
      <CBPRatesDialog
        open={openCBPRatesDialog}
        setOpen={setOpenCBPRatesDialog}
        openBackdrop={openBackdrop}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        fetchData={fetchData}
        cbpRateInvoices={cbpRateInvoices}
        setCBPRateInvoices={setCBPRateInvoices}
        cbpId={cbpId}
      />
    </>
  );
};

export default CbpRates;
